export default __webpack_public_path__ + "static/media/rail.2c646760.jpg";